import React from "react";
import { Box, Container, Grid, Typography, Link, Divider } from "@mui/material";
import { Facebook, Twitter, Instagram } from "@mui/icons-material";
import { useNavigate } from "react-router-dom"; 

const Footer = () => {
  const navigate = useNavigate(); 

  const handleNavigate = (path) => {
    navigate(path); 
  };

  return (
    <Box sx={{ backgroundColor: "#f7f7f7", padding: "50px 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={2} marginBottom={2}>
              <Box
                component="img"
                src="/images/logo.png"
                alt="Company Logo"
                sx={{
                  width: "150px",
                  height: "auto", 
                  objectFit: "contain", 
                  transition: "transform 0.3s", 
                  "&:hover": { transform: "scale(1.1)" }, 
                }}
              />
              {/* <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>
                Spring Creek Cabinetry
              </Typography> */}
            </Box>
            <Typography
              variant="body2"
              sx={{ color: "#4B4B4B", marginBottom: "20px" }}
            >
              Transform your spaces with premium cabinetry solutions. We
              specialize in custom designs using top-quality materials to meet
              your every need.
            </Typography>
            <Typography variant="caption" sx={{ color: "#8A8A8A" }}>
              Copyright © 2024 Spring Creek
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#f97316",
                marginBottom: "10px",
              }}
            >
              Services
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/contact")}
              >
                Custom Cabinetry
              </Link>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/contact")}
              >
                Kitchen Remodeling
              </Link>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/contact")}
              >
                Furniture Design
              </Link>
            </Box>
          </Grid>

          {/* 材料部分 */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#f97316",
                marginBottom: "10px",
              }}
            >
              Materials
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/gallery?material=Melamine")}
              >
                Melamine
              </Link>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/gallery?material=PET")}
              >
                PET
              </Link>
              <Link
                underline="none"
                sx={{
                  color: "#000",
                  cursor: "pointer",
                  transition: "color 0.3s, transform 0.3s",
                  "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                }}
                onClick={() => handleNavigate("/gallery?material=Thermofoil")}
              >
                Thermofoil
              </Link>
            </Box>
          </Grid>

          {/* 关注我们部分 */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#f97316",
                marginBottom: "10px",
              }}
            >
              Follow Us
            </Typography>
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Box display="flex" alignItems="center" gap={1}>
                <Facebook sx={{ color: "#000" }} />
                <Link
                  underline="none"
                  sx={{
                    color: "#000",
                    cursor: "pointer",
                    transition: "color 0.3s, transform 0.3s",
                    "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                  }}
                  href="https://facebook.com"
                >
                  Facebook
                </Link>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Twitter sx={{ color: "#000" }} />
                <Link
                  underline="none"
                  sx={{
                    color: "#000",
                    cursor: "pointer",
                    transition: "color 0.3s, transform 0.3s",
                    "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                  }}
                  href="https://twitter.com"
                >
                  Twitter
                </Link>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Instagram sx={{ color: "#000" }} />
                <Link
                  underline="none"
                  sx={{
                    color: "#000",
                    cursor: "pointer",
                    transition: "color 0.3s, transform 0.3s",
                    "&:hover": { color: "#f97316", transform: "scale(1.05)" },
                  }}
                  href="https://instagram.com"
                >
                  Instagram
                </Link>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ marginY: "20px" }} />

        {/* Terms & Privacy 部分，添加动画效果 */}
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{ marginTop: "10px" }}
        >
          <Link
            underline="none"
            sx={{
              color: "#8A8A8A",
              cursor: "pointer",
              transition: "color 0.3s, transform 0.3s",
              "&:hover": {
                color: "#f97316",
                transform: "scale(1.1)",
              },
            }}
            onClick={() => handleNavigate("/terms")}
          >
            Terms & Conditions
          </Link>
          <Link
            underline="none"
            sx={{
              color: "#8A8A8A",
              cursor: "pointer",
              transition: "color 0.3s, transform 0.3s",
              "&:hover": {
                color: "#f97316",
                transform: "scale(1.1)",
              },
            }}
            onClick={() => handleNavigate("/privacy")}
          >
            Privacy Policy
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
